module.exports = __webpack_public_path__ + "static/media/ac-img.e05db35d.jpg";